"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.UIConfigSchema = exports.nodeType = void 0;
const v4_1 = require("zod/v4");
exports.nodeType = 'file_generatedCashBalanceFeed';
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database.
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
// well not completely, because it may be modified by synthetic node creation
// later.
exports.artifactType = 'generatedCashBalanceFeed';
//# sourceMappingURL=types.js.map